const formatter = new Intl.NumberFormat('pt-BR', {
	style: 'decimal',
	//currency: 'BRL',
	minimumFractionDigits: 2,
	maximumFractionDigits: 2
});

const formatterSimbolo = new Intl.NumberFormat('pt-BR', {
	style: 'currency',
	currency: 'BRL',
	currencyDisplay: 'symbol',
	minimumFractionDigits: 2,
	maximumFractionDigits: 2
});

const formatterCubagem = new Intl.NumberFormat('pt-BR', {
	style: 'decimal',
	minimumFractionDigits: 4,
	maximumFractionDigits: 4
});

const dateFormatter = new Intl.DateTimeFormat('pt-BR');
const dateTimeFormatter = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric'
});

let materialSelectCounter = 0;

import * as moment from 'moment';
import 'moment/locale/pt-br';
moment.locale('pt-BR');

export default class StHelper {

    constructor() {

        throw new Error('Esta classe não pode ser instanciada');
    }

    static equals(obj1, obj2) {
        let v1 = JSON.stringify(obj1);
        let v2 = JSON.stringify(obj2);
        return v1 == v2;
    }

    static clone(obj) {
        let json = JSON.stringify(obj);
        return JSON.parse(json);
    }

    static formatReal(vl) {
        return formatter.format(vl?vl:0);
    }
    static formatPercAcrescimoDesconto(vl) {
        let v = formatter.format(vl?vl:0);
        if (v.startsWith('-')) v = v.replace('-','+');
        return v;
    }
    static formatValorAcrescimoDesconto(vl) {
        let v = formatterSimbolo.format(vl?vl:0);
        if (v.startsWith('-')) v = v.replace('-','+');
        return v;
    }

    static formatRealSimbolo(vl) {
        return formatterSimbolo.format(vl?vl:0);
    }

    static formatVolume(vl) {
        return formatterCubagem.format(vl?vl:0);
    }

    static formatData(vl) {
        if (vl) {
            let dt = new Date(vl);
            return dateFormatter.format(dt);
        } else {
            return '';
        }
    }

    static formatDataHora(vl) {
        if (vl) {
            let dt = new Date(vl);
            return dateTimeFormatter.format(dt);
        } else {
            return '';
        }
    }
    static toDateInput(vl) {
        if (vl) {
            if (vl.toISOString) {
                vl = vl.toISOString();
            }
            return vl.split('T')[0];
        } 
        return vl;
    }

    static fromDateInputToWebservice(vl) {
        return `${vl}T00:00:00-03:00`;
    }

    static resolveTempoGarantia(tempoGarantiaItem, tempoGlobalGarantia) {
        const prazoItem = Number(tempoGarantiaItem);
        if (Number.isFinite(prazoItem) && prazoItem > 0) return prazoItem;

        const prazoGlobal = Number(tempoGlobalGarantia);
        return Number.isFinite(prazoGlobal) && prazoGlobal > 0 ? prazoGlobal : null;
    }

    static calculaPrazoGarantia(dataEmissao, tempoGarantiaItem, tempoGlobalGarantia, periodoEmDias) {
        const prazo = StHelper.resolveTempoGarantia(tempoGarantiaItem, tempoGlobalGarantia);
        if (!dataEmissao || prazo === null) return false;

        const unidade = periodoEmDias ? 'days' : 'months';
        const dataLimite = moment.default(new Date(dataEmissao)).startOf('day').add(prazo, unidade);
        return !dataLimite.isBefore(moment.default().startOf('day'));
    }


    static firstName(string) {
        if (string && string.includes(' ')) {
            return string.split(' ')[0];
        } else {
            return string;
        }
    }

    static setDefaultDatePicker(selector) {
        if (selector) {
            $(selector).pickadate({
                selectMonths: true, // Creates a dropdown to control month
                selectYears: 15, // Creates a dropdown of 15 years to control year
                labelMonthNext: 'Próximo Mês',
                labelMonthPrev: 'Mês Anterior',
                labelMonthSelect: 'Selecione um mês',
                labelYearSelect: 'Selecione um ano',
                monthsFull: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
                monthsShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
                weekdaysFull: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
                weekdaysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
                weekdaysLetter: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
                today: 'Hoje',
                clear: 'Limpar',
                close: 'Ok',
                format: 'dd/mm/yyyy',
                onSet: function(thing) {
                    let event = new CustomEvent('change', {
                        detail: 'change',
                        bubbles: true
                    });
                    $(this.$node).get(0).dispatchEvent(event);
                }
            });
        }
    }

    static arredondar(num, casas) {
        let fator = 0;
        if (casas == 2) fator = 100;
        else if (casas == 4) fator = 10000;
        else fator = Math.pow(10,casas?casas:2);
        return StHelper.fastRound(num * fator) / fator;
    }

    static fastRound(n) {
        return (n + 0.5) << 0;
    }

    static idFromResponse(response) {
        let localizacao = response.headers.get('Location');
        if (localizacao) {
            let arr = localizacao.split('/');
            let codigo = arr[arr.length - 1];
            return parseInt(codigo);
        } else {
            return null;
        }
    }

    static idStringFromResponse(response) {
        let localizacao = response.headers.get('Location');
        if (localizacao) {
            let arr = localizacao.split('/');
            let codigo = arr[arr.length - 1];
            return codigo;
        } else {
            return null;
        }
    }
    
    static range (start, end) { return [...Array(1+end-start).keys()].map(v => start+v) };


	static lpad(str, padString, length) {
		str = str+'';
		while (str.length < length)
			str = padString + str;
		return str;
	}

    static removeCaracteresEspeciais(inputString) {
        let exp = /\^|~|\?|,|\*|\.|\-|\//g;
        return inputString.replace(exp, "");
    }

    static validaFormatoEmail(email) {
        let exp = /^[a-zA-Z0-9][a-zA-Z0-9\._-]+@([a-zA-Z0-9\._-]+\.)[a-zA-Z-0-9]{2,3}/g;
        return exp.test(email);
    }

    static formataTelefone(tel) {
        if (!tel) {
            return '';
        } else if (tel.length == 11) {
            let formatted = tel.replace(/^(\d{2})(\d{5})(\d{4}).*/, '($1) $2-$3');
            return formatted;
        } else if (tel.length == 10){
            let formatted = tel.replace(/^(\d{2})(\d{4})(\d{4}).*/, '($1) $2-$3');
            return formatted;
        } else {
            return tel;
        }
    }

    static toastAlerta(msg) {
		Materialize.toast(msg,5000,'deep-orange darken-3');
    }

    static toastAlertaPositive(msg, time = 4000) {
        if(msg) Materialize.toast(msg,time, 'green darken-3');
    }

    static toastAlertaNegative(msg, time = 6000) {
        if(msg) Materialize.toast(msg,time, 'red darken-3');
    }
    
    static quebraLinha(texto) {
        if (texto) {
            return texto.replace(/<<csr>>/g,'<br>').replace(/\n/g,'<br>').replace(/<<csq>>/g,'<br>');
        } else {
            return '';
        }
    }

    static _filteredComponents(arr) {
        let toUpdate = [];
        if (arr) {
            if (arr.forEach) {
                arr.forEach(el=>{
                    if (el) toUpdate.push(el);
                });
            } else {
                toUpdate.push(arr);
            }
        }
        return toUpdate;
    }

    static updateMaterializeFields(arr ) {
        let elements = StHelper._filteredComponents(arr);
        Materialize.updateTextFields(elements);         
    }

    static activateMaterialSelect(arr) {
        let elements = StHelper._filteredComponents(arr);
        materialSelectCounter = 0;
        let el = $(elements);
        el.material_select();
        el.off('change');
        el.on('change', function() {
            materialSelectCounter++;
            if (materialSelectCounter == 1) {
                let event = new CustomEvent('change', {
                    detail: 'change',
                    bubbles: true
                });
                $(this).get(0).dispatchEvent(event);
            } else if (materialSelectCounter >= 2) {
                materialSelectCounter = 0;
            }
        });
    }
    
    // static validarCnpj(cnpj) {
    //     let exp = /([0-9]{2}[\.]?[0-9]{3}[\.]?[0-9]{3}[\/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[\.]?[0-9]{3}[\.]?[0-9]{3}[-]?[0-9]{2})/g;
    //     return exp.test(cnpj);
    // }

    static validarCnpj(cnpj) {
        
           cnpj = cnpj.replace(/[^\d]+/g,'');
        
           if(cnpj == '') return false;
            
           if (cnpj.length != 14)
               return false;
        
           // Elimina CNPJs invalidos conhecidos
           if (cnpj == "00000000000000" || 
               cnpj == "11111111111111" || 
               cnpj == "22222222222222" || 
               cnpj == "33333333333333" || 
               cnpj == "44444444444444" || 
               cnpj == "55555555555555" || 
               cnpj == "66666666666666" || 
               cnpj == "77777777777777" || 
               cnpj == "88888888888888" || 
               cnpj == "99999999999999")
               return false;
                
           // Valida DVs
           let tamanho = cnpj.length - 2
           let numeros = cnpj.substring(0,tamanho);
           let digitos = cnpj.substring(tamanho);
           let soma = 0;
           let pos = tamanho - 7;
           for (let i = tamanho; i >= 1; i--) {
             soma += numeros.charAt(tamanho - i) * pos--;
             if (pos < 2)
                   pos = 9;
           }
           let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
           if (resultado != digitos.charAt(0))
               return false;
                
           tamanho = tamanho + 1;
           numeros = cnpj.substring(0,tamanho);
           soma = 0;
           pos = tamanho - 7;
           for (let i = tamanho; i >= 1; i--) {
             soma += numeros.charAt(tamanho - i) * pos--;
             if (pos < 2)
                   pos = 9;
           }
           resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
           if (resultado != digitos.charAt(1))
                 return false;
                  
           return true;
    }

    /**
     *  Compara o mês entre duas datas, retorna 0 caso os meses sejam iguais, retorna 1 caso o primeiraData seja maior que 
     *  a segunda, retorna -1 caso a primeiraData seja menor que a segunda.
     * @param {Date} primeiraData 
     * @param {Date} segundaData 
     */
    static compararMesEntreDatas(primeiraData, segundaData){        
        return moment.default(primeiraData).month()==moment.default(segundaData).month()?0:moment.default(primeiraData).month()<moment.default(segundaData).month()?-1:1;
    }

    static findGetParameter(parameterName) {
        let result = null,
            tmp = [],
            initialSearchIndex = location.hash.search(/\?/g) + 1;
        location.hash
            .substr(initialSearchIndex)
            .split("&")
            .forEach(function(item) {
                tmp = item.split("=");
                if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
            });
        return result;
    }

    /**
     *  Recebe uma string no formato DD/MM/YYYY (formato padrão da string que os datepickers do materialize retorna)
     *  e retorna uma data do tipo nativo do javascript
     * @param {String} stringDate 
     */
    static stringToDate(stringDate) {
        if (stringDate) {
            if (stringDate.includes('/')) {
                let year = stringDate.substr(6,4), month = stringDate.substr(3,2), day = stringDate.substr(0,2);
                return new Date(year, --month, day);
            } else {
                //yyyy-mm-dd
                if (stringDate.length == 10) {
                    stringDate = `${stringDate}T00:00:00-03:00`;
                }
                return new Date(stringDate);
            }
        } else {
            return null;
        }
    }
    
    /**
     *  Compara duas datas, retorna 0 caso elas sejam iguais, retorna 1 caso o primeiraData seja maior que 
     *  a segundaData, retorna -1 caso a primeiraData seja menor que a segundaData.
     * @param {Date} primeiraData 
     * @param {Date} segundaData 
     */
    static compararDatas(primeiraData, segundaData) {
        const momentPrimeiraData = moment.default(primeiraData);
        const momentSegundaData = moment.default(segundaData);
        if(momentPrimeiraData.isSame(momentSegundaData, 'day')) {
            // Primeira data é igual a segunda data
            return 0;
        } else if(momentPrimeiraData.isBefore(momentSegundaData)) {
            // Primeira data é menor que a segunda data
            return -1;
        } else {
            // Primeira data é maior que segunda data
            return 1
        }
    }

    static tratarDate(dt) {
		if (!(dt instanceof Date)) {
			if (dt.includes('/')) {
				dt = moment.default(dt, "DD/MM/YYYY").toDate();
			} else {
				dt = new Date(dt);
			}
		}
		return dt;
    }
    
    static dateToIso8601(data){
        let dt = this.tratarDate(data);
        return moment.default(dt).format();
    }

	static truncateDate(dt) {
		if (dt) {
			dt = StHelper.tratarDate(dt);
			let nd = new Date(dt.getTime());
			nd.setHours(0,0,0);
			return nd;
		} else {
			return null;
		}
	}
	static firstDayOfYear(dt) {
		if (dt) {
			dt = StHelper.tratarDate(dt);
			let nd = new Date(dt.getTime());
            nd.setHours(0,0,0);
            nd.setDate(1);
            nd.setMonth(0);
			return nd;
		} else {
			return null;
		}
	}

	static endOfDay(dt) {
		if (dt) {
			dt = StHelper.tratarDate(dt);
			let nd = new Date(dt.getTime());
			nd.setHours(23,59,59);
			return nd;
		} else {
			return null;
		}
	}

	static dateEquals(dt1Param, dt2Param) {
        if(!dt1Param || ! dt2Param) {
            throw new Error('Impossivel comparar as datas quando um dos parâmetro é nulo');
        }

        const dt1 = new Date(dt1Param);
        const dt2 = new Date(dt2Param);
        
		return dt1.getFullYear() === dt2.getFullYear() &&
			dt1.getMonth() === dt2.getMonth() &&
			dt1.getDate() === dt2.getDate();
	}

    static dateIsBetween(dt, dtFrom, dtTo) {
        if (!dt) return false;
        return StHelper.truncateDate(dt) >= StHelper.truncateDate(dtFrom) 
            && StHelper.truncateDate(dt) <= StHelper.truncateDate(dtTo) ;
    }

	static isToday(dt) {
		return StHelper.dateEquals(new Date(), dt);
	}

	static booleanToSn(bol) {
		return bol?'S':'N';
	}
	static snToBoolean(sn) {
		return sn === 'S' || sn === 's'? true:false;
	}
	
	static safeTrim(v) {
		if (!v) return '';
		else v.trim();
    }
    
    static getLocalStorageItem(key, defaultValue) {
        let ret = localStorage.getItem(key);
        if (!ret || ret == 'undefined') {
            return defaultValue;
        } else {
            return ret;
        }
    }

    /**
     * Adiciona a quantidade de dias passados no parâmetro days a data informada na variavel date
     * 
     * @param {Date} date 
     * @param {int} days 
     */
    static adicionarDias(date, days) {            
        return moment.default(date).add(days, 'd').toDate();
    }

    /**
     * Adiciona a quantidade de mêses passados no parâmetro months a data informada na variavel date
     * 
     * @param {Date} date 
     * @param {int} months 
     */
    static adicionarMeses(date, months) {            
        return moment.default(date).add(months, 'M').toDate();
    }

    /**
     * Adiciona a quantidade de anos passados no parâmetro years a data informada na variavel date
     * 
     * @param {Date} date 
     * @param {int} years 
     */
    static adicionarAnos(date, years) {            
        return moment.default(date).add(years, 'y').toDate();
    }

    /**
     * Adiciona a quantidade de horas passados no parâmetro hours a data informada na variavel date
     * 
     * @param {Date} date 
     * @param {int} hours 
     */
    static adicionarHoras(date, hours) {            
        return moment.default(date).add(hours, 'h').toDate();
    }

    /**
     * Adiciona a quantidade de minutos passados no parâmetro minutes a data informada na variavel date
     * 
     * @param {Date} date 
     * @param {int} minutes 
     */
    static adicionarMinutos(date, minutes) {            
        return moment.default(date).add(minutes, 'm').toDate();
    }

    /**
     * Adiciona a quantidade de segundos passados no parâmetro seconds a data informada na variavel date
     * 
     * @param {Date} date 
     * @param {int} seconds 
     */
    static adicionarSegundos(date, seconds) {            
        return moment.default(date).add(seconds, 's').toDate();
    }

    static formataStatusCobrancaEletronica(status) {
        // return status.replace('_', ' ');

        switch(status) {
            case 'ENVIAR_EMAIL':
                return 'Enviar Email';
                break;
            case 'REENVIAR_EMAIL':
                return 'Reenviar Email';
                break;
            case 'AGUARDANDO_COBRANCA':
                return 'Aguardando Cobrança';
                break;
            case 'AGUARDANDO_COBRANCA_DIRETA':
                return 'Aguardando Cobrança Direta';
                break;
            case 'AGUARDANDO_PAGAMENTO':
                return 'Aguardando Pagamento';
                break;
            case 'COBRANCA_EFETUADA_AGUARDANDO_EXPORTACAO_ERP':
                return 'Cobrança Efetuada Aguandando Exportação ERP';
                break;
            case 'COBRANCA_COM_PROBLEMAS':
                return 'Cobrança com Problemas';
                break;
            case 'CANCELADO':
                return 'Cancelado';
                break;
            case 'EXPORTADO':
                return 'Exportado';
                break;
            case 'REEMBOLSADO_COM_SUCESSO':
                return 'Reembolsado com Sucesso';
                break;
            case 'PROBLEMAS_COM_REEMBOLSO':
                return 'Problemas com Reembolso';
                break;
            case 'REEMBOLSO_SOLICITADO':
                return 'Reembolso Solicitado';
                break;
            case 'REEMBOLSO_EXPORTADO':
                return 'Reemboso Exportado';
                break;
            default:
                return 'Não definido';
        }
    }

    static formataUneg(uneg) {
        switch(uneg) {
            case '1;':
                return 'G&B';
                break;
            case '2;':
                return 'MTO';
                break;
        }
    }

    static formataPerfilUsuario(perfil) {
        let perfilFormatado = '';
        
        if (!perfil) {
            return perfilFormatado;
        }

        if (perfil.includes('I')) {
            perfilFormatado += 'Vendedor Interno; ';
        }
        if (perfil.includes('E')) {
            perfilFormatado += 'Vendedor Externo; ';
        }
        if (perfil.includes('R')) {
            perfilFormatado += 'Representante; ';
        }
        if (perfil.includes('C')) {
            perfilFormatado += 'Cliente; ';
        }
        return perfilFormatado;
    }

    static formatCep(cep) {
        if(!cep) 
            return null;

        return `${cep.substring(0, 5)}-${cep.substring(5, 8)}`;

    }

    static formatCnpj(cnpj) {
        if(!cnpj){
            return null;
        }
        let v = cnpj.toString();

        while(v.length < 14){ // adiciona zeros a esquerda se necessario para a mascara funcionar
            v = '0' + v;
        }

        let s = v.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5"); 
        //let s = v.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3/\$4-\$5"); 
        //let s = v.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
        return s;
    }

    
    /** 
     * adiciona tooltipped quanto o texto for trincado 
     * e um evento para chamar este método quando a tela for redimensionado
     * par remover o tooltipped se o texto não for mais truncado
     * @since 1.23.00 
     * @author Amaro Silva
     */
    static truncateActive() {
        const elements = document.querySelectorAll('.truncateActive');

        if (!elements || elements.length == 0) return;
        
        elements.forEach(element => {
            if(element && element.scrollWidth > element.clientWidth) {
                element.classList.add('tooltipped');
                element.dataset.tooltip = element.textContent.trim();
                $(element).tooltip({delay: 50, html: true});
            } else {
                element.classList.remove('tooltipped');
                delete element.dataset.tooltip;
                $(element).tooltip('remove');
            }; 
        });

        window.addEventListener("resize", this.truncateActive);
    }

    static formatPedcRefExternoWithoutPipe(val) {
        if(val.includes('|')) {
            return val.split('|')[1];
        } else {
            return val;
        }
    }

    static calcularMrgItem(sku, valorUnitarioLiquido, quantidade, valorCustoUnitario) {
        

        if (!valorUnitarioLiquido || !valorCustoUnitario) {
            return 0;
        }

        quantidade = !quantidade || quantidade <= 0 ? 1 : quantidade;

        let vlLiq = this.arredondar(valorUnitarioLiquido * quantidade) ;
        let computedMarkup = this.arredondar(vlLiq - (valorCustoUnitario * quantidade), 2);
        let total = this.arredondar((computedMarkup / vlLiq)*100,2);
                
        if (isNaN(total)) {
            return 0;
        }

        return total;
    }

}



// WEBPACK FOOTER //
// ./src/components/helpers/StHelper.js